import { BUTTONS } from "locales/locales";
import * as React from "react";
import { useTranslation } from "react-i18next";

export const CommandCell = ({
    edit,
    dataItem,
    remove,
    add,
    discard,
    update,
    cancel,
    editField}:any) => {

  const inEdit = dataItem[editField];
  const isNewItem = dataItem._id === undefined;
 const { t } = useTranslation()
 
  return inEdit ? (
    <td className="k-command-cell">
      <button
        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command"
        onClick={() =>
          isNewItem ? add(dataItem) : update(dataItem)
        }
      >
        {isNewItem ? t(BUTTONS.ADD) : t(BUTTONS.UPDATE)}
      </button>
      <button
        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-cancel-command"
        onClick={() =>
          isNewItem ? discard(dataItem) : cancel(dataItem)
        }
      >
        {isNewItem ? t(BUTTONS.DISCARD) : t(BUTTONS.CANCEL)}
      </button>
    </td>
  ) : (
    <td className="k-command-cell">
      <button
        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary k-grid-edit-command"
        onClick={() => edit(dataItem)}
      >
        {t(BUTTONS.EDIT)}
      </button>
      <button
        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-remove-command"
        onClick={() =>
          //confirm("Confirm deleting: " + dataItem.ProductName) && //-> this using for js alert. its coming from browser. 
          remove(dataItem)
          
        }
      >
        {t(BUTTONS.DELETE)}
      </button>
    </td>
  );
};